function parseSDF(str, options = {}) {
    const atoms = [[]];

    let noH = false;

    if (typeof options.keepH !== "undefined") noH = !options.keepH;

    const lines = str.split(/\r?\n|\r/);

    while (lines.length > 0) {
        if (lines.length < 4) break;

        const atomCount = parseInt(lines[3].substr(0, 3));

        if (isNaN(atomCount) || atomCount <= 0) break;

        const bondCount = parseInt(lines[3].substr(3, 3));
        let offset = 4;

        if (lines.length < 4 + atomCount + bondCount) break;

        // serial is atom"s index in file; index is atoms index in "atoms"
        const serialToIndex = [];
        const start = atoms[atoms.length - 1].length;
        const end = start + atomCount;

        for (let i = start; i < end; i++, offset++) {
            const line = lines[offset];
            const atom = {};
            const elem = line.substr(31, 3).replace(/ /g, "");
            atom.atom = atom.elem = elem[0].toUpperCase() + elem.substr(1).toLowerCase();

            if (atom.elem !== "H" || !noH) {
                atom.serial = i;
                serialToIndex[i] = atoms[atoms.length - 1].length;
                atom.x = parseFloat(line.substr(0, 10));
                atom.y = parseFloat(line.substr(10, 10));
                atom.z = parseFloat(line.substr(20, 10));
                atom.hetflag = true;
                atom.bonds = [];
                atom.bondOrder = [];
                atom.properties = {};
                atom.index = atoms[atoms.length - 1].length;
                atoms[atoms.length - 1].push(atom);
            }
        }

        for (let i = 0; i < bondCount; i++, offset++) {
            const line = lines[offset];

            const from = serialToIndex[parseInt(line.substr(0, 3)) - 1 + start];
            const to = serialToIndex[parseInt(line.substr(3, 3)) - 1 + start];
            const order = parseInt(line.substr(6, 3));

            if (typeof (from) != "undefined" && typeof (to) != "undefined") {
                atoms[atoms.length - 1][from].bonds.push(to);
                atoms[atoms.length - 1][from].bondOrder.push(order);
                atoms[atoms.length - 1][to].bonds.push(from);
                atoms[atoms.length - 1][to].bondOrder.push(order);
            }
        }

        if (options.multimodel) {
            if (!options.onemol) atoms.push([]);

            while (lines[offset] !== "$$$$") offset++;

            lines.splice(0, ++offset);
        } else break;
    }

    return atoms;
}

export default parseSDF;
export { parseSDF };